<div class="well center-text">
  <h3 class="">{{'ASSESSMENT_OUR'  | translate}}</h3>
  <img class="assessment-img" src="{{assetsUrl}}" alt="Resultat">
  <h4>{{subTitle | translate}}</h4>
  <ng-container *ngIf="subDesc">
    <div class="pt-0">{{subDesc  | translate}}</div>
  </ng-container>
</div>
